import ActionButton, { type ActionButtonProps } from 'components/ActionButton';
import { useFormContext } from 'components/ReactHookForm';
import type { WithOptional } from 'types';
import { is } from 'utils/helpers';

type Props = WithOptional<
	Omit<ActionButtonProps, 'customState' | 'type'>,
	'onClick'
>;

export default function SubmitButton({
	children,
	displayWidth = 'full',
	variant = 'cta',
	...rest
}: Props) {
	const { hookFormContext } = useFormContext();

	const { errors, isSubmitting } = hookFormContext.formState;
	return (
		<ActionButton
			{...rest}
			type="submit"
			variant={variant}
			displayWidth={displayWidth}
			customState={
				isSubmitting
					? 'loading'
					: // isSubmitSuccessful exists, but switches too quickly
						// leading to wrong button state occasionally.
						// Having errors is more stable.
						is.objectWithKeys(errors)
						? 'failure'
						: 'success'
			}
		>
			{children}
		</ActionButton>
	);
}
SubmitButton.displayName = 'ReactHookForm_SubmitButton';
